import React, {useEffect, useRef, useState} from "react";
import {format, startOfWeek} from "date-fns";
import {ResourceProps, useSchedules} from "../hooks/useSchedules";
import {ChevronLeft, ChevronRight, Plus} from "lucide-react";
import {formatDateForCalendar} from "../../../utils/formatDate";
import {useCustomToolbar} from "../../components/customToolbar/useCustomToolbar";
import Select from "react-select";
import classNames from "classnames";
import {reactSelectStyles} from "../../../subframe";
import {useBreakpoint} from "../../../utils/useBreakpoint";
import {DayPicker, getDefaultClassNames} from "react-day-picker";
import {useQuery} from "../../../utils/useQuery";
import {Path} from "../../../path";
import {useApp} from "../../../useApp";

interface ToolbarProps {
    currentDate: Date;
    calendarView: "day" | "week" | "month";
    onNavigate:any
    onViewChange: (view: "day" | "week" | "month") => void;
    resources: ResourceProps[];
    selectedResourceId?: number;
    onResourceChange?: (resourceId: number) => void;
    onNewBookingClick?: () => void;
    onQuickCheckout?: () => void;
    selectedEmployee:any;
    employees:any
    setSelectedEmployee:any
    onNewAppointmentInit:any
    shops:any
    shop:any



}

const Toolbar: React.FC<ToolbarProps> = ({selectedEmployee,
    onNewAppointmentInit,
                                             onQuickCheckout,
    setSelectedEmployee,employees,
                                             currentDate,
                                             calendarView,
                                             onNavigate,
                                             onViewChange,
                                             resources,
                                             selectedResourceId,
                                             onResourceChange,
                                             onNewBookingClick,
                                             shops,
                                             shop
    // onNavigate,
    // props
                                         }) => {

    const query=useQuery()
    const { navigate } = useApp();
    const { isBelowXl } = useBreakpoint("xl");
    const [showPicker, setShowPicker] = useState(false)
    const defaultClassNames = getDefaultClassNames();
    const containerRef = useRef<any>(null);
    // const { date, view, onNavigate, onView } = props; // 🔥 from react-big-calendar

    // const { onShopsChange, goToBack, goToNext, shops, shop } = useCustomToolbar({
    //     onNavigate:onNavigation,
    // });

    const [selected, setSelected] = useState<any>('')




    useEffect(() => {
        if (selectedEmployee){
            setSelectedEmployee(selectedEmployee)
            query.set('employeeId',selectedEmployee.id.toString())
        }


    }, [selectedEmployee]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                containerRef.current &&
                !containerRef.current.contains(event.target as Node)
            ) {
                setShowPicker(false);
            }
        };

        if (showPicker) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showPicker]);
    const onShopsChange = (selectedOption: any) => {

        query.delete("shopId");
        query.set("shopId", selectedOption.value);
        navigate(`${Path.HOME}?${query.toString()}`);
    };


    return (
        <div className="flex flex-col gap-3 lg:gap-0 lg:flex-row lg:items-center lg:justify-between px-2 py-4 border-b border-gray-200 bg-white">
            {/* Stays stacked until lg so the action buttons fit on tablets */}
            <div className="flex items-center space-x-4">
                <div className="flex items-center space-x-2">
                    <button
                        onClick={() => {
                            onNavigate(currentDate,calendarView,'PREV')
                        }}
                        className="p-2 hover:bg-gray-100 rounded-lg"
                    >
                        <ChevronLeft className="w-5 h-5" />
                    </button>
                    <span onClick={() => setShowPicker(!showPicker)} ref={containerRef} className="text-lg font-medium text-gray-900 min-w-[200px] text-center">
                  {calendarView==='day' ? format(currentDate, "MMMM dd, yyyy") : format(currentDate, "MMMM yyyy")}
                        {/*{showPicker &&*/}

                        {/*    <div className="absolute bg-white z-[1000] shadow-sm p-2 rounded-md border border-neutral-50 transform translate-x-[-26%] translate-y-[10%]">*/}
                        {/*        <div className="flex justify-center">*/}
                        {/*    <DayPicker*/}
                        {/*    mode="single"*/}
                        {/*    numberOfMonths={2}*/}
                        {/*    selected={currentDate}*/}
                        {/*    onSelect={(dateToGo) => {*/}
                        {/*        if (!dateToGo) return;*/}
                        {/*         onNavigate(dateToGo,calendarView,'DATE')*/}

                        {/*        if (calendarView === "week") {*/}
                        {/*            const startWeek = startOfWeek(dateToGo, {*/}
                        {/*                weekStartsOn: 0,*/}
                        {/*            });*/}
                        {/*            onNavigate(startWeek);*/}
                        {/*        } else {*/}
                        {/*            onNavigate(dateToGo);*/}
                        {/*        }*/}
                        {/*        // setShowPicker(false);*/}
                        {/*    }}*/}
                        {/*    styles={{*/}
                        {/*        day: {*/}
                        {/*            cursor: "pointer",*/}
                        {/*            // add background hover effect*/}
                        {/*        },*/}
                        {/*    }}*/}
                        {/*    classNames={{*/}
                        {/*        today: `text-millet-800 !rounded-lg`, // Highlight the current day*/}
                        {/*        selected: `bg-millet-800 !text-white !rounded`, // Highlight the selected day*/}
                        {/*        day: `${defaultClassNames.day} !rounded hover:!bg-millet-600`, // Adds hover effect*/}
                        {/*        day_button: `${defaultClassNames.day_button} !rounded hover:!bg-millet-100`,*/}
                        {/*        chevron: `${defaultClassNames.chevron} !fill-millet-800`,*/}
                        {/*        root: `${defaultClassNames.root} rounded`,*/}
                        {/*    }}*/}
                        {/*/>*/}
                        {/*        </div></div>}*/}
                </span>
                    <button
                        onClick={() => onNavigate(currentDate,calendarView,'NEXT')}
                        className="p-2 hover:bg-gray-100 rounded-lg"
                    >
                        <ChevronRight className="w-5 h-5" />
                    </button>
                </div>
            </div>
            <Select
                value={{
                    value: shop?.id,
                    label: shop?.name,
                }}
                key={`shop-select-${shop?.id}`}
                className={classNames(
                    "text-sm shadow-none rounded-[4px] w-full hover:bg-gray-100 max-w-[200px]",
                    {
                        "max-w-[15%]": isBelowXl,
                    }
                )}
                options={shops.map((shop:any) => ({
                    value: shop.id,
                    label: shop.name,
                    complete: shop?.latitude && shop?.longitude && shop.addressLine1,
                }))}
                onChange={onShopsChange}
                placeholder="Select Shop"
                defaultValue={{
                    value: shop?.id,
                    label: shop?.name,
                }}
                styles={{
                    ...reactSelectStyles({
                        borderContainer: true,
                    }),
                    control: (base) => ({
                        ...base,
                        boxShadow: "none",
                        border: "none",
                        backgroundColor: "transparent",
                        "&:hover": { border: "none" },
                    }),
                }}
                isOptionDisabled={(option: any) => !option.complete}
            />

            {/* Phones: view switcher on its own row, then the two actions side by side at full width */}
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end flex-1 sm:gap-4">
                <div className="flex bg-gray-100 rounded-lg p-1 self-start sm:self-auto">
                    {(['day', 'week', 'month'] as const).map((mode) => (
                        <button
                            key={mode}
                            onClick={() => onViewChange(mode)}
                            className={`px-4 py-2 rounded-md text-sm font-medium capitalize ${
                                calendarView === mode
                                    ? 'bg-white text-gray-900 shadow-sm'
                                    : 'text-gray-600 hover:text-gray-900'
                            }`}
                        >
                            {mode}
                        </button>
                    ))}
                </div>

                {calendarView!=='day' && selectedEmployee && <select
                     defaultValue={selectedEmployee?.id}
                    value={selectedEmployee?.id}
                    onChange={(e) => {
                        setSelectedEmployee(employees.find((em: any) => em.id.toString() === e.target.value.toString()))
                    }}
                    className="text-sm border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                    {calendarView==='month'&& <option value="all">All Providers</option>}
                    {employees.map((practitioner:any) => (
                        <option key={practitioner.id} value={practitioner.id}>{practitioner.name}</option>
                    ))}
                </select>}

                <div className="grid grid-cols-2 gap-2 sm:flex sm:gap-4">
                    <button
                        onClick={onQuickCheckout}
                        className="bg-green-400 text-white px-4 py-2 rounded-lg whitespace-nowrap"
                    >
                        Quick Checkout
                    </button>
                    <button
                         onClick={onNewAppointmentInit}
                        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center justify-center space-x-2 whitespace-nowrap"
                    >
                        <Plus className="w-4 h-4" />
                        <span>New Booking</span>
                    </button>
                </div>
            </div>

        </div>
    );
};

export default Toolbar;
